import axios from 'axios';
import { endOfYesterday, isMonday, startOfYesterday, subDays } from 'date-fns';

const state = {
  settings: {
    donationType: 'All',
    campaignType: 'All',
    exportType: 'All',
    supporterType: 'All',
    // Get fri to sun donations on monday
    dateRange: {
      start: isMonday(new Date()) ? subDays(startOfYesterday(), 2) : startOfYesterday(),
      end: endOfYesterday(),
    },
  },
  csvfieldsOrder: ['problem_column', 'SUP_ConsID', 'SUP_DTL_Email', 'SUP_DTL_Titl1', 'SUP_DTL_FirstName', 'SUP_DTL_LastName', 'SUP_DTL_Gender', 'SUP_DTL_Bday', 'SUP_CON_AddrCountry', 'SUP_CON_AddrCity', 'SUP_CON_AddrState', 'SUP_CON_AddrZip', 'SUP_CON_AddrLine1', 'SUP_CON_AddrLine2', 'SUP_CON_Organisation', 'SUP_CON_PhoneNum', 'SUP_CON_PhoneType', 'SUP_CON_RequestNoEmail', 'GFT_CampaignID', 'GFT_FundID', 'GFT_AppealID', 'GFT_PackageID', 'GFT_DonationType', 'GFT_Date', 'GFT_StartDate', 'GFT_PayMeth', 'GFT_Amount', 'GFT_AttrDesc', 'GFT_AttrDesc2', 'GFT_AttrDesc3', 'GFT_Receipted', 'PAY_DD_AcctName', 'PAY_DD_AcctNum', 'PAY_DD_Branch', 'PAY_DD_BSBNum', 'PAY_DD_BSBFinInst', 'PAY_CC_CardHolderName', 'PAY_CC_CardExpiry', 'PAY_CC_CardNum', 'PAY_CC_CardType', 'RCP_AddrCountry', 'RCP_AddrCity', 'RCP_AddrState', 'RCP_AddrZip', 'RCP_AddrLine1', 'RCP_AddrLine2', 'RCP_Titl1', 'RCP_FirstName', 'RCP_LastName', 'RCP_Gender', 'RCP_ID', 'RCP_attr1', 'RCP_attr2', 'RCP_attr3', 'RCP_attr4', 'RCP_attr5', 'GFT_Ref', 'GFT_ImpID', 'consentToBequest', 'creditcard_masked_num', 'addr_validated', 'SUP_DTL_email_validated', 'DPP_ID'],
  csvfieldsOrderDon: ['problem_column', 'addr_change_reason', 'FieldName', 'phone_change_reason', 'SUP_ConsID', 'SUP_DTL_Email', 'SUP_DTL_Titl1', 'SUP_DTL_FirstName', 'SUP_DTL_LastName', 'SUP_DTL_Gender', 'SUP_DTL_Bday', 'SUP_CON_AddrCountry', 'SUP_CON_AddrCity', 'SUP_CON_AddrState', 'SUP_CON_AddrZip', 'SUP_CON_AddrLine1', 'SUP_CON_AddrLine2', 'SUP_CON_Organisation', 'SUP_CON_PhoneNum', 'SUP_CON_PhoneType', 'SUP_CON_RequestNoEmail', 'GFT_CampaignID', 'GFT_FundID', 'GFT_AppealID', 'GFT_PackageID', 'GFT_DonationType', 'GFT_Date', 'GFT_PayMeth', 'GFT_Amount', 'GFT_AttrDesc', 'GFT_AttrDesc2', 'GFT_Receipted', 'PAY_DD_AcctName', 'PAY_DD_AcctNum', 'PAY_DD_Branch', 'PAY_DD_BSBNum', 'PAY_DD_BSBFinInst', 'PAY_CC_CardHolderName', 'PAY_CC_CardExpiry', 'PAY_CC_CardNum', 'PAY_CC_CardType', 'GFT_ImpID', 'consentToBequest', 'creditcard_masked_num', 'addr_validated', 'SUP_DTL_email_validated', 'DPP_ID'],
};

const getters = {};

const actions = {
  // getDonationsExports(state, { startDate, endDate }) {
  //    return axios.get(`/exports-data/donations?startDate=${startDate}&endDate=${endDate}`, { responseType: 'arraybuffer' })
  // },
  fetchDonations({ state }) {
    const settings = state.settings;

    // Construct query string
    let query = `?startDate=${settings.dateRange.start.toISOString()}&endDate=${settings.dateRange.end.toISOString()}`;
    for (const [key, value] of Object.entries(settings)) {
      if (value !== 'All' && key !== 'dateRange') {
        query += `&${key}=${value}`;
      }
    }

    return axios.get(`/exports-data${query}`);
  },

  markAsExported({ state }) {
    const settings = state.settings;
    const startDate = settings.dateRange.start.toISOString();
    const endDate = settings.dateRange.end.toISOString();
    return axios.post('/exports-data/mark-as-exported', { startDate, endDate })
  }
};

const mutations = {
  setSettings: (state, settings) => state.settings = { ...settings }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};